export class TRCFundClasses{
    revenue_type = ""
    description = ""
    measure = 0
//    INC0754669 - Enhancement - PFA EappReg - Adding GGR
    ggr = ''
    taxPeriod = ""
	dateFrom=""
	dateTo=""
	transactionType = ""
	principal = ""
	interest = ""
	penalty=""
	creditAmt=""
	isReadOnly=false;
	entryType=""
	isCredit=false
	initialMeasureInd=0
	payReceipt=""
	rowTotal=""
	currentTaxPeriod=false;
	obPeriodType=""
}